import type { Profile } from '@/entities/profile';

export const InteractionTypes = {
  MEET: 1,
  MEET_REQUEST: 2,
  MEET_REFUSE: 3,
  TRUST_REQUESTED: 4,
  TRUST_ACCEPTED: 5,
  TRUST_REFUSED: 6,
  HOBBIES: 7,
  TV_PREFERENCES: 8,
  LIFESTYLE: 9,
  QUESTION: 10,
  VISIT: 11,
  PERSONAL_QUESTION: 12,
  MEET_ARCHIVED: 13,
  ACCEPT_SHARING: 14,
  REFUSE_SHARING: 15,
} as const;

export type InteractionTypeId = (typeof InteractionTypes)[keyof typeof InteractionTypes];

export interface Interaction {
  id: number;
  fromNodeId: number;
  toNodeId: number;
  interactionTypeId: InteractionTypeId;
  createdAt: string;
}

export interface DashboardData {
  nearbyProfiles: Profile[];
  meetRequestsWaiting: Interaction[];
  meetRequestsReceived: Interaction[];
  trustRequestsWaiting: Interaction[];
  trustRequestsReceived: Interaction[];
  profileCompletion: number;
  profileViews?: number;
  matchCount?: number;
  messageCount?: number;
  trustRequestsReceivedCount?: number;
}
